// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__G_TZa","tagButton":"styles_tagButton__JnZjr","icon":"styles_icon__CGODH","label":"styles_label__OutxV"};